/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BasketReturnModel } from './BasketReturnModel';
import {
    BasketReturnModelFromJSON,
    BasketReturnModelFromJSONTyped,
    BasketReturnModelToJSON,
} from './BasketReturnModel';
import type { ShippingMethodReturnModel } from './ShippingMethodReturnModel';
import {
    ShippingMethodReturnModelFromJSON,
    ShippingMethodReturnModelFromJSONTyped,
    ShippingMethodReturnModelToJSON,
} from './ShippingMethodReturnModel';

/**
 * 
 * @export
 * @interface BasketResponseModel
 */
export interface BasketResponseModel {
    /**
     * 
     * @type {BasketReturnModel}
     * @memberof BasketResponseModel
     */
    basket?: BasketReturnModel;
    /**
     * 
     * @type {Array<ShippingMethodReturnModel>}
     * @memberof BasketResponseModel
     */
    shippingMethods?: Array<ShippingMethodReturnModel>;
}

/**
 * Check if a given object implements the BasketResponseModel interface.
 */
export function instanceOfBasketResponseModel(value: object): boolean {
    return true;
}

export function BasketResponseModelFromJSON(json: any): BasketResponseModel {
    return BasketResponseModelFromJSONTyped(json, false);
}

export function BasketResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasketResponseModel {
    if (json == null) {
        return json;
    }
    return {
        
        'basket': json['basket'] == null ? undefined : BasketReturnModelFromJSON(json['basket']),
        'shippingMethods': json['shippingMethods'] == null ? undefined : ((json['shippingMethods'] as Array<any>).map(ShippingMethodReturnModelFromJSON)),
    };
}

export function BasketResponseModelToJSON(value?: BasketResponseModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'basket': BasketReturnModelToJSON(value['basket']),
        'shippingMethods': value['shippingMethods'] == null ? undefined : ((value['shippingMethods'] as Array<any>).map(ShippingMethodReturnModelToJSON)),
    };
}

